/**
 * The titles of upgrades this tab has shown, so the header's accessible name on an upgrade screen
 * (src/app.tsx screenTitle) is the upgrade's own title, like a task's (src/board-cache.ts
 * recallTask). Memory only: a cold load says "Upgrade" until the screen has fetched it.
 */
const titles = new Map<string, string>();

export function rememberUpgradeTitle(id: string, title: string): void {
  titles.set(id, title);
}

export function recallUpgradeTitle(id: string): string | null {
  return titles.get(id) ?? null;
}
